<template>
	<div>
		<o-skeleton circle :width="px" :height="px" class="is-align-items-center"></o-skeleton>
		<o-skeleton
			circle
			:width="px"
			:height="px"
			:count="3"
			class="is-align-items-center is-flex-direction-row is-justify-content-space-around"></o-skeleton>
	</div>
</template>
<script>
	import { ref } from "vue";
	export default {
		props: {
			size: {
				type: String,
				default: "sm"
			}
		},
		setup(props, context) {
			const px = ref();

			switch (props.size) {
				case "xs": {
					px.value = "32px";
					break;
				}
				case "sm": {
					px.value = "64px";
					break;
				}
				case "md": {
					px.value = "86";
					break;
				}
				case "lg": {
					px.value = "128px";
					break;
				}
			}

			return {
				px
			};
		}
	};
</script>